import React, {useState} from 'react';
import useFeature from "../../../useFeature";
import {ProductDetailFeature} from "./ProductDetailFeature";
import {useApplication} from "../../../ApplicationProvider";
import {useNavigate, useParams} from "react-router-dom";
import {observer} from "mobx-react";
import MoneyRenderer from "../../utils/MoneyRenderer";
import {ModalDeliveryPointAndPurchaseOrderNumber} from "./ModalDeliveryPointAndPurchaseOrderNumber";
import {ModalCantEditOrderWhenItsNotInInitialState} from "./ModalCantEditOrderWhenItsNotInInitialState";
import {AddToCartModal,} from "./AddToCartModal";
import SystemUpdateAltOutlinedIcon from '@mui/icons-material/SystemUpdateAltOutlined';
import Inventory2OutlinedIcon from "@mui/icons-material/Inventory2Outlined";

const truncatePrice = (price) => Math.floor(price);
const obtenerDecimales = (price) => price.toFixed(2).split('.')[1];

const ProductDetailScreen = () => {
    const application = useApplication()
    const {id} = useParams();
    const feature = useFeature(() => new ProductDetailFeature(application, id))
    const navigator = useNavigate()
    const usosProducto = [
        // Example data, replace with actual logic
        'url1.jpg',
        'url2.jpg'
    ];
    const [addToCartModalOpen, setAddToCartModalOpen] = useState(false)

    const isFeatureReady = (feature) => {
        return feature && feature.loaded
    }

    return isFeatureReady(feature) && (
        <div className="container">
            <div className="row item-detail-container flex">
                <div className="col-sm-6 col-md-5 col-md-offset-1">
                    <div className="flex-header-product-detail">
                        <ol className="breadcrumb">
                            <li><a href="#" className="category">Categorías</a></li>
                            <li><a href="#">Productos</a></li>
                        </ol>
                        <a className="visible-xs" style={{paddingTop: "2em"}}>
                            <div className="favourite">
                                <div className="title-info-product general-title">
                                    {/*<FontAwesomeIcon*/}
                                    {/*    icon={faHeart}*/}
                                    {/*    className={`${feature.productOrder().UsuarioCliente.Favoritos.some(x => x.Id === feature.productDetail().Id) ? 'hide' : ''}`}*/}
                                    {/*/>*/}
                                    {/*<FontAwesomeIcon*/}
                                    {/*    icon={faHeart}*/}
                                    {/*    className={`${!feature.productOrder().UsuarioCliente.Favoritos.some(x => x.Id === feature.productDetail().Id) ? 'hide' : ''}`}*/}
                                    {/*    style={{color: '#c1a17d'}}*/}
                                    {/*/>*/}
                                </div>
                            </div>
                        </a>
                    </div>

                    <div className="img-box-product visible-xs">
                        <img src={feature.productImage()} className="img-responsive img-producto-categoria"
                             alt="Foto de Categoría"/>
                    </div>
                    <a href="#" data-toggle="modal" data-target="#zoom-img" className="hidden-xs">
                        <div className="img-box-product">
                            <img src={feature.productImage()} className="img-responsive img-producto-categoria"
                                 alt="Foto de Categoría"/>
                        </div>
                        {/*<p className="zoom general-title hidden-xs">Zoom <FontAwesomeIcon icon={faSearch}/></p>*/}
                    </a>
                </div>

                <div className="col-sm-6 col-md-5 col-md-offset-1">
                    {/*<FavouriteButton itemId={feature.productDetail().id}/>*/}
                    <div className="info-product">
                        <img src={feature.logoImage()} className="img-responsive img-logo-category"
                             alt="Imagen del logo de producto"/>
                        <h3 className="title-product">{feature.productDetail().Producto.NombreFantasia}</h3>
                        <p className="description-product clearfix" style={{ fontFamily: 'ArcherSmbd, sans-serif', fontWeight: 'bold' }}>{feature.productDetail().Producto.Descripcion}</p>
                    </div>

                    <div className="costo-product">
                        <p className="general-title title-info-product">Costo unitario</p>
                        <p className="precio">
                            {(() => {
                                const { whole, decimals } = parsePrice(MoneyRenderer(feature.productPrice()));
                                return (
                                    <>
                                        <span className="pesos">{whole}</span>
                                        <span className="centavos"><sup>{decimals}</sup></span>
                                    </>
                                );
                            })()}
                        </p>
                        {feature.canAddProduct() && (
                            <a
                                className={`btn btn-primary btn-add-to-cart ${feature.productOrder().VerModalMultiplePuntoEntrega ? 'punto-entrega-elegir' : 'agregar-articulo'}`}
                                href={`#${feature.productDetail().Id}`}
                                onClick={() => setAddToCartModalOpen(true)}
                            >
                                Añadir
                            </a>
                        )}
                    </div>

                </div>
            </div>

            <div className="row row-info">
                <div className="col-sm-6 col-md-5 col-md-offset-1">
                    {/*<div className={`product-uses ${usosProducto.length ? '' : 'hide'}`}>*/}
                    {/*    <p className="general-title">Usos del producto</p>*/}
                    {/*    {usosProducto.map((item, index) => (*/}
                    {/*        <a key={index} href="#" className="product-uses-container" data-toggle="modal"*/}
                    {/*           data-target="#modal-uso-producto">*/}
                    {/*            <div className="product-uses-hover-img">*/}
                    {/*                <FontAwesomeIcon icon={faCamera} />*/}
                    {/*            </div>*/}
                    {/*            <div className="img-usos-producto">*/}
                    {/*                <img src={saporFirstDetailedProduct} className="img-responsive"*/}
                    {/*                     alt="Foto de Categoría"/>*/}
                    {/*            </div>*/}
                    {/*        </a>*/}
                    {/*    ))}*/}
                    {/*    <div className="clearfix"/>*/}
                    {/*</div>*/}

                    <div className="ficha-tecnica visible-xs clearfix">
                        <p className="general-title title-info-product">Ficha Técnica</p>
                        <table className="table">
                            <tbody>
                            <tr className={`${feature.productDetail().CantidadUnidades === 0 ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        <Inventory2OutlinedIcon/>
                                    </span>
                                </td>
                                <td>{feature.productDetail().UnidadDeItems} por caja</td>
                                <td>{`${feature.productDetail().CantidadUnidades}`}</td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.Peso ? 'hide' : ''}`}>
                                <td>
                                    <span
                                    className="material-symbols-outlined"
                                    style={{
                                        color: '#5e5d5d',
                                        fontSize: "1.2em",
                                        marginRight: "5px",
                                        position: "relative",
                                        top: "4px"
                                    }}>
                                        <SystemUpdateAltOutlinedIcon/>
                                    </span>
                                </td>
                                <td>Peso</td>
                                <td>{`${feature.productDetail().Producto.Peso}gr`}</td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.Medidas ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        straighten
                                    </span>
                                </td>
                                <td>Medidas</td>
                                <td>{`${feature.productDetail().Producto.Medidas}cm`}</td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.TiempoDeCoccion ? 'hide' : ''}`}>
                                <td><span
                                    className="material-symbols-outlined"
                                    style={{
                                        color: '#5e5d5d',
                                        fontSize: "1.2em",
                                        marginRight: "5px",
                                        position: "relative",
                                        top: "4px"
                                    }}
                                >
                                        schedule
                                    </span></td>
                                <td>Tiempo de cocción</td>
                                <td>{`${feature.productDetail().Producto.TiempoDeCoccion}min`}</td>
                            </tr>
                            {feature.productDetail().Producto.TemperaturaDeCoccion && (
                                <tr>
                                    <td><span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginLeft: "0px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        thermostat
                                    </span></td>
                                    <td>Temperatura de cocción</td>
                                    <td>{`${feature.productDetail().Producto.TemperaturaDeCoccion}º`}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        {feature.hasSpecificationSheet() && (
                            <div className="ficha-tecnica visible-xs clearfix" style={{paddingLeft: "1em"}}>
                                {/*<p className="general-title title-info-product">Ficha técnica</p>*/}
                                {/*<hr className="margintop0"/>*/}
                                <a href={feature.specificationSheet()} target="_blank" className="download"
                                   style={{
                                       display: 'flex',
                                       alignItems: 'center',
                                       gap: '8px',
                                       textDecoration: 'none',
                                       color: '#acacac',
                                   }}
                                >
                            <span className="material-symbols-outlined"
                                  style={{
                                      fontSize: "1.5em",
                                      color: "#acacac",
                                  }}
                            >
                                cloud_download
                            </span>
                                    <span className="general-title">
                                    descargar ficha técnica en .pdf
                                </span>
                                </a>
                            </div>
                        )}
                    </div>
                        {feature.productDetail().Producto.Ingredientes && (
                            <div className="ingredientes visible-xs margintop50">
                                <p className="general-title title-info-product">Ingredientes</p>
                                <hr className="margintop0"/>
                                <p className="clearmargin" style={{fontFamily: 'archerSmbd'}}>{feature.productDetail().Producto.Ingredientes}</p>
                                <hr/>
                            </div>
                        )}


                        {/*{feature.recommendedProducts().length > 0 && (*/}
                    {/*    <div className="recommends">*/}
                    {/*        <div className="row">*/}
                    {/*            <div className="col-xs-12 recommends-title">*/}
                    {/*                <p className="general-title hidden-xs"><span className="brandonBd primary">Sapore te recomienda que pruebes</span>*/}
                    {/*                </p>*/}
                    {/*                <p className="general-title visible-xs text-center"><span*/}
                    {/*                    className="brandonBd primary font16">Sapore te recomienda que pruebes</span></p>*/}
                    {/*            </div>*/}

                    {/*            <div className="col-xs-12">*/}
                    {/*                <div className="owl-carousel" id="carousel-product-detail">*/}
                    {/*                    {feature.recommendedProducts().map((item, index) => (*/}
                    {/*                        <div key={index} className="recommendation-box">*/}
                    {/*                            <div className="recommendation-box-img">*/}
                    {/*                                <a href={ID_PRODUCT_DETAIL_PATH} className="img-box">*/}
                    {/*                                    <img src={saporFirstDetailedProduct} className="img-responsive"*/}
                    {/*                                         alt="Foto de Categoría"/>*/}
                    {/*                                </a>*/}
                    {/*                            </div>*/}
                    {/*                            <div className="recommendation-box-footer">*/}
                    {/*                                <a href={ID_PRODUCT_DETAIL_PATH}>*/}
                    {/*                                    <p className="h6">{item.Producto.Nombre}</p>*/}
                    {/*                                </a>*/}
                    {/*                                <p className="h3 none">$ <span id="precio-producto">XX,XX</span></p>*/}
                    {/*                                {!feature.productOrder().UsuarioCliente.EsAdministrador && (*/}
                    {/*                                    <a className={`btn btn-primary btn-sm btn-outlined ${feature.productOrder().VerModalMultiplePuntoEntrega ? 'punto-entrega-elegir' : 'agregar-articulo'}`}*/}
                    {/*                                       href={`#${item.Id}`}>Añadir</a>*/}
                    {/*                                )}*/}
                    {/*                            </div>*/}
                    {/*                        </div>*/}
                    {/*                    ))}*/}
                    {/*                </div>*/}
                    {/*            </div>*/}
                    {/*        </div>*/}
                    {/*    </div>*/}
                    {/*)}*/}
                </div>

                <div className="col-sm-6 col-md-4 col-md-offset-1 hidden-xs">
                    <div className="ficha-tecnica clearfix">
                        <p className="general-title title-info-product">Ficha técnica</p>
                        <table className="table">
                            <tbody>
                            <tr className={`${feature.productDetail().CantidadUnidades === 0 ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        <Inventory2OutlinedIcon/>
                                    </span>
                                </td>
                                <td>{`${feature.itemsUnitTitle(feature.productDetail())}`} por caja</td>
                                <td>{`${feature.productDetail().CantidadUnidades} ${feature.itemUnitAbbreviation(feature.productDetail())}`} </td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.Peso ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        <SystemUpdateAltOutlinedIcon/>
                                    </span>
                                </td>
                                <td>Peso</td>
                                <td>{`${feature.productDetail().Producto.Peso}gr`}</td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.Medidas ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        straighten
                                    </span>
                                </td>
                                <td>Medidas</td>
                                <td>{`${feature.productDetail().Producto.Medidas}cm`}</td>
                            </tr>
                            <tr className={`${!feature.productDetail().Producto.TiempoDeCoccion ? 'hide' : ''}`}>
                                <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginRight: "5px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        schedule
                                    </span>
                                </td>
                                <td>Tiempo de cocción</td>
                                <td>{`${feature.productDetail().Producto.TiempoDeCoccion}min`}</td>
                            </tr>
                            {feature.productDetail().Producto.TemperaturaDeCoccion && (
                                <tr>
                                    <td>
                                    <span
                                        className="material-symbols-outlined"
                                        style={{
                                            color: '#5e5d5d',
                                            fontSize: "1.2em",
                                            marginLeft: "0px",
                                            position: "relative",
                                            top: "4px"
                                        }}
                                    >
                                        thermostat
                                    </span>
                                    </td>
                                    <td>Temperatura de cocción</td>
                                    <td>{`${feature.productDetail().Producto.TemperaturaDeCoccion}º`}</td>
                                </tr>
                            )}
                            </tbody>
                        </table>
                        {feature.hasSpecificationSheet() && (
                            <a href={feature.specificationSheet()} target="_blank" className="download"
                               style={{
                                   display: 'flex',
                                   alignItems: 'center',
                                   gap: '8px',
                                   textDecoration: 'none',
                                   color: '#acacac',
                               }}
                            >
                            <span className="material-symbols-outlined"
                                  style={{
                                      fontSize: "1.5em",
                                      color: "#acacac",
                                  }}
                            >
                                cloud_download
                            </span>
                                <span className="general-title">
                                    descargar ficha técnica en .pdf
                                </span>
                            </a>
                        )}
                    </div>
                    <div
                        className={`ingredientes hidden-xs margintop30 ${!feature.productDetail().Producto.Ingredientes ? 'hide' : ''}`}>
                        <p className="general-title title-info-product">Ingredientes</p>
                        <hr className="margintop0"/>
                        <p className="clearmargin" style={{fontFamily: 'ArcherSmbd', fontWeight: 'bold'}}>{feature.productDetail().Producto.Ingredientes}</p>
                    </div>
                    <hr/>
                </div>
            </div>

            <hr className="divider-line footer-line marginbottom0"/>
            {/*<div className="modal fade modal-zoom" id="zoom-img" tabIndex="-1" role="dialog">*/}
            {/*    <div className="modal-dialog modal-lg" role="document">*/}
            {/*        <div className="modal-content">*/}
            {/*            <div className="modal-header">*/}
            {/*                <img src={saporeLogo} alt="Logo Sapore Di Pane"/>*/}
            {/*                <button type="button" className="close general-title" data-dismiss="modal"*/}
            {/*                        aria-label="Close">*/}
            {/*                    Cerrar <FontAwesomeIcon icon={faTimesCircle} className="font24 pe-va" />*/}
            {/*                </button>*/}
            {/*            </div>*/}
            {/*            <div className="modal-body">*/}
            {/*                <img src={saporFirstDetailedProduct}*/}
            {/*                     className="img-responsive" alt="Foto de Producto"/>*/}
            {/*            </div>*/}
            {/*            <div className="modal-footer">*/}
            {/*                <div className="row">*/}
            {/*                    <div className="col-sm-8">*/}
            {/*                        <div className="d-flex">*/}
            {/*                            <img src={levainLogo} alt=""/>*/}
            {/*                            <h5 className="title-modal-zoom">{feature.productDetail().Producto.NombreFantasia}</h5>*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                    <div className="col-sm-4">*/}
            {/*                        <div className="costo-product">*/}
            {/*                            <span className="general-title">Costo <br/>unitario</span>*/}
            {/*                            <p className="precio">${truncatePrice(feature.productPrice())}<sup>{obtenerDecimales(feature.productPrice())}</sup>*/}
            {/*                            </p>*/}
            {/*                            {feature.productOrder().Cliente.Descuento && (*/}
            {/*                                <p className="precio">precio<sup></sup>*/}
            {/*                                </p>*/}
            {/*                            )}*/}
            {/*                        </div>*/}
            {/*                    </div>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}

            {/*<div className="modal fade modal-uses-product modal-zoom" id="modal-uso-producto" tabIndex="-1"*/}
            {/*     role="dialog">*/}
            {/*    <div className="modal-dialog modal-lg" role="document">*/}
            {/*        <div className="modal-content">*/}
            {/*            <div className="modal-header">*/}
            {/*                <button type="button" className="close general-title" data-dismiss="modal"*/}
            {/*                        aria-label="Close">*/}
            {/*                    Cerrar <FontAwesomeIcon icon={faTimesCircle} className="font24 pe-va" />*/}
            {/*                </button>*/}
            {/*            </div>*/}
            {/*            <div className="modal-body">*/}
            {/*                <div id="carousel-example-generic" className="carousel carousel-fade slide"*/}
            {/*                     data-ride="carousel" data-interval="false">*/}
            {/*                    <div className="carousel-inner" role="listbox">*/}
            {/*                        {usosProducto.map((item, index) => (*/}
            {/*                            <div key={index} className={`item ${index === 0 ? 'active' : ''}`}>*/}
            {/*                                <div className="item-box-img">*/}
            {/*                                    <img src={item} alt="..."/>*/}
            {/*                                </div>*/}
            {/*                            </div>*/}
            {/*                        ))}*/}
            {/*                    </div>*/}
            {/*                    <a className="left carousel-control" href="#carousel-example-generic" role="button"*/}
            {/*                       data-slide="prev">*/}
            {/*                        <span className="pe-7f-angle-left"></span>*/}
            {/*                        <span className="sr-only">Previous</span>*/}
            {/*                    </a>*/}
            {/*                    <a className="right carousel-control" href="#carousel-example-generic" role="button"*/}
            {/*                       data-slide="next">*/}
            {/*                        <span className="pe-7f-angle-right"></span>*/}
            {/*                        <span className="sr-only">Next</span>*/}
            {/*                    </a>*/}
            {/*                </div>*/}
            {/*            </div>*/}
            {/*        </div>*/}
            {/*    </div>*/}
            {/*</div>*/}
            <ModalCantEditOrderWhenItsNotInInitialState
                open={feature.isModalCantEditOrderOpened}
                feature={feature}
            />
            <AddToCartModal
                open={addToCartModalOpen}
                setOpen={setAddToCartModalOpen}
                handleAddToCart={(quantity) => feature.addProductToCart(quantity)}
                product={feature.productDetailInformation}/>
            <ModalDeliveryPointAndPurchaseOrderNumber
                open={feature.isDeliveryPointModalOpened}
                handleSetDelivery={(deliveryPointName, deliveryDate, purchaseOrderNumber) => { feature.setDelivery(deliveryPointName, deliveryDate, purchaseOrderNumber) }}
                puntosEntrega={feature.deliverySites}
                feature={feature}
                navigator={navigator}
            />
        </div>
    );
};

const parsePrice = (priceStr) => {
    if (priceStr == null) {
        return { whole: "0", decimals: "00", priceNumber: 0 };
    }

    const priceNumber = parseFloat(priceStr) || 0;

    const [whole, decimals = "00"] = priceStr.split(',');

    const formattedDecimals = (decimals.length === 1) ? decimals + "0" : decimals.slice(0, 2);

    return {
        whole,
        decimals: formattedDecimals,
        priceNumber
    };
};

export default observer(ProductDetailScreen);
